import React, { Suspense } from "react";
const HomePage = React.lazy(() => import("./pages/HomePage"));

function App() {

  return (
    <>
      <Suspense fallback={null}>
        <HomePage />
      </Suspense>
    </>
  )
}

export default App